import React from 'react';
import Button from '../../components/Button';
import Caret from '../../components/Caret';
import SVGIcon from '../../components/SVGIcon';
import checkIcon from '../../icons/non-prefilled/16x16/check.svg';
import type { TutorialName } from '../onboardingSlice';
import { OnboardingActions } from '../onboardingSlice';
import useOnboardingData from '../useOnboardingData';
import styles from './TutorialListItem.module.scss';
import { useAppDispatch } from '../../app/redux/useAppSelector';

interface TutorialListItemProps {
  children: React.ReactNode;
  icon: React.ReactNode;
  name: TutorialName;
  onClick: () => void;
  to?: string;
}

const TutorialListItem = ({
  icon,
  name,
  children,
  to,
  onClick,
}: TutorialListItemProps) => {
  const { onReset, onboarding } = useOnboardingData(name);
  const dispatch = useAppDispatch();
  const handleClick = () => {
    onReset();
    dispatch(OnboardingActions.setActiveTutorial(name));
    onClick();
  };

  return (
    <Button className={styles.container} onClick={handleClick} to={to}>
      {icon}
      <div className={styles.content}>{children}</div>
      {onboarding && (onboarding.completedAt || onboarding.skippedAt) ? (
        <SVGIcon className={styles.check}>{checkIcon}</SVGIcon>
      ) : (
        <Caret direction="right" size="regular" />
      )}
    </Button>
  );
};

export default TutorialListItem;
